import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function Modal({ isOpen, onClose, title, children, footer }) {
    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        className="fixed inset-0 bg-[#020617]/80 z-[80] backdrop-blur-md"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                    />

                    {/* Modal */}
                    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 pointer-events-none">
                        <motion.div
                            className="bg-[#0f172a] rounded-[2.5rem] border border-white/10 shadow-[0_0_50px_-12px_rgba(79,70,229,0.3)] w-full max-w-lg overflow-hidden pointer-events-auto relative"
                            initial={{ opacity: 0, scale: 0.95, y: 10 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.95, y: 10 }}
                        >
                            {/* Decorative Background */}
                            <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-600/10 blur-3xl -z-10"></div>

                            <div className="p-8">
                                <div className="flex justify-between items-center mb-8 border-b border-white/5 pb-6">
                                    <h3 className="text-xl font-bold text-white tracking-tight uppercase tracking-widest text-[11px] opacity-40">
                                        {title}
                                    </h3>
                                    <button
                                        onClick={onClose}
                                        className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-white/40 hover:text-white hover:bg-white/10 transition-all pointer-events-auto"
                                    >
                                        <X size={18} />
                                    </button>
                                </div>

                                <div className="text-white/80 mb-8 overflow-y-auto max-h-[60vh]">
                                    {children}
                                </div>

                                {footer && (
                                    <div className="flex justify-end gap-3 pointer-events-auto pt-4 border-t border-white/5">
                                        {footer}
                                    </div>
                                )}
                            </div>
                        </motion.div>
                    </div>
                </>
            )}
        </AnimatePresence>
    );
}
